import { IconProps } from './IconProps';
export function BulbIcon(props: IconProps) {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_4229_40006)">
                <path
                    d="M12 22V23.5"
                    stroke="#66182A"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15 17.2852V20.0002C15 21.4262 13.8 22.0002 12 22.0002C10.2 22.0002 9 21.4262 9 20.0002V17.2852"
                    stroke="#66182A"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 17.197V13L10 11"
                    stroke="#66182A"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.5 17.5C15.6977 17.0252 16.7221 16.1965 17.4368 15.1245C18.1515 14.0526 18.5223 12.7882 18.5 11.5C18.4694 9.78564 17.7748 8.15004 16.5624 6.93761C15.3499 5.72518 13.7143 5.03055 12 5C10.2856 5.03055 8.65001 5.72518 7.43759 6.93761C6.22516 8.15004 5.53053 9.78564 5.49998 11.5C5.47762 12.7882 5.84849 14.0526 6.56315 15.1245C7.27781 16.1965 8.30229 17.0252 9.49998 17.5H14.5Z"
                    stroke="#66182A"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 19.5H15"
                    stroke="#66182A"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 0.5V2.5"
                    stroke="#66182A"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M1 10.5H3.291"
                    stroke="#66182A"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.5 3L5.5 5"
                    stroke="#66182A"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M23 10.5H20.709"
                    stroke="#66182A"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20.5 3L18.5 5"
                    stroke="#66182A"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 13L14 11"
                    stroke="#66182A"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_4229_40006">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
